export default __webpack_public_path__ + "static/equal-opportunity-lender-logo-3e39dbb273d5c91cc1c5765c969f5996.svg";